import AttendHelpListPage from './AttendHelpListPage';

export default AttendHelpListPage;
